import { claimTypeValues } from '@/common/constants'

export const claimTypeOptions = [
  { value: claimTypeValues.carrierMarkedDeliveredNotReceived, label: 'Entrega sin completar' },
  {
    value: claimTypeValues.possiblyLostNoTrackingUpdates,
    label: 'Paquete posiblemente perdido - Seguimiento sin actualizaciones recientes',
  },
  { value: claimTypeValues.deliveredDamagedOrMissingItems, label: 'Entrega con daños visibles o productos faltantes' },
  { value: claimTypeValues.packageHeldAtCustoms, label: 'Paquete retenido en aduanas' },
]
